import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _6kIcon(props: IconProps) {
    return <Icon {...props} iconKey={"6k"}/>
}
